(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vore-product-carousel"] && !Shopify.designMode) return;
  try {
    
  /* Elimina productos repetidos entre carruseles, solo en fichas de producto (data-dedupe). Los carruseles con data-priority conservan sus productos. */
  function voreDedupeCarousels() {
    var all = Array.from(document.querySelectorAll('vore-carousel[data-dedupe]'));
    if (all.length < 2) return;
    var ordered = all.filter(function (c) { return c.hasAttribute('data-priority'); }).concat(all.filter(function (c) { return !c.hasAttribute('data-priority'); }));
    var seen = {};
    ordered.forEach(function (c) {
      c.querySelectorAll('.vore-carousel__item[data-handle]').forEach(function (it) {
        var h = it.dataset.handle;
        if (seen[h]) it.remove(); else seen[h] = true;
      });
      var left = c.querySelectorAll('.vore-carousel__item').length;
      c.hidden = left === 0;
      if (c.update) c.update();
    });
  }
  if (!customElements.get('vore-carousel')) {
    class VoreCarousel extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        this.prev = this.querySelector('[data-dir="-1"]');
        this.next = this.querySelector('[data-dir="1"]');
        if (!this.track) return;
        this.querySelectorAll('.vore-arrow').forEach((btn) => {
          btn.addEventListener('click', () => this.move(Number(btn.dataset.dir)));
        });
        this.track.addEventListener('scroll', () => this.update(), { passive: true });
        window.addEventListener('resize', () => this.update(), { passive: true });
        this.update();
        voreDedupeCarousels();
      }
      move(dir) {
        const item = this.track.querySelector('.vore-carousel__item');
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 12;
        const step = item ? (item.getBoundingClientRect().width + gap) * 2 : this.track.clientWidth;
        this.track.scrollBy({ left: dir * step, behavior: 'smooth' });
      }
      update() {
        const t = this.track;
        if (!t) return;
        if (this.prev) this.prev.disabled = t.scrollLeft <= 2;
        if (this.next) this.next.disabled = t.scrollLeft + t.clientWidth >= t.scrollWidth - 2;
      }
    }
    customElements.define('vore-carousel', VoreCarousel);
  }
  if (!customElements.get('vore-recommendations')) {
    class VoreRecommendations extends HTMLElement {
      connectedCallback() {
        const url = this.dataset.url;
        if (!url) return;
        fetch(url)
          .then((r) => r.text())
          .then((html) => {
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const carousel = doc.querySelector('vore-carousel');
            if (carousel) this.replaceWith(carousel); else this.remove();
          })
          .catch(() => this.remove());
      }
    }
    customElements.define('vore-recommendations', VoreRecommendations);
  }

  } catch(e) { console.error(e); }
})();
})();
